import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconMylist = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 5314",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 241",
				d: "M13.3738 10.6261L10.6263 13.3737C10.4387 13.5612 10.1844 13.6666 9.91916 13.6666H2.33337C1.2288 13.6666 0.333374 12.7712 0.333374 11.6666V2.33325C0.333374 1.22868 1.2288 0.333252 2.33337 0.333252H11.6667C12.7713 0.333252 13.6667 1.22868 13.6667 2.33325V9.91904C13.6667 10.1843 13.5614 10.4386 13.3738 10.6261Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector 240",
				d: "M10.6667 9.66667L13 9.66667L9.66667 13L9.66667 10.6667C9.66667 10.1144 10.1144 9.66667 10.6667 9.66667Z",
				fill: "#707070"
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "MY",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M10.1245 8.32524C10.1245 8.63991 9.87386 8.83191 9.56453 8.83191C9.24986 8.83191 9.00453 8.63991 9.00453 8.32524L9.0152 6.83191L7.68186 4.92257C7.61253 4.82657 7.5752 4.70391 7.5752 4.58657C7.5752 4.41591 7.64453 4.24524 7.78853 4.13324C7.88986 4.05857 8.01253 4.02124 8.1352 4.02124C8.28986 4.02124 8.4392 4.07991 8.54586 4.21857L9.5592 5.63191L10.5725 4.21857C10.6845 4.08524 10.8339 4.02124 10.9885 4.02124C11.1112 4.02124 11.2285 4.05857 11.3299 4.13324C11.4739 4.24524 11.5432 4.41591 11.5432 4.58657C11.5432 4.70391 11.5059 4.82657 11.4365 4.92257L10.1245 6.79991V8.32524Z",
					fill: "#707070"
				}), /* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M5.3997 6.83187C5.2397 7.0132 5.0797 7.09854 4.9197 7.09854C4.75436 7.09854 4.59436 7.00787 4.44503 6.83187L3.7357 6.0212V8.34654C3.7357 8.5972 3.5277 8.8372 3.1917 8.8372C2.86636 8.8372 2.6637 8.5972 2.6637 8.34654V4.5012C2.6637 4.25054 2.86636 4.01587 3.1917 4.01587C3.3677 4.01587 3.55436 4.1012 3.6717 4.23454L4.92503 5.69054L6.1677 4.23454C6.27436 4.10654 6.47703 4.01587 6.65303 4.01587C6.9197 4.01587 7.1757 4.19187 7.1757 4.5012V8.34654C7.1757 8.5972 6.9677 8.8372 6.6317 8.8372C6.30636 8.8372 6.1037 8.5972 6.1037 8.34654V6.0212L5.3997 6.83187Z",
					fill: "#707070"
				})]
			})
		]
	})
});
export default SvgIconMylist;
